export default __webpack_public_path__ + "static/media/inicio-cronometro.e2885144.png";